import Vue from 'vue';
import main from './main.vue';

let instance = null;
const types = ['success', 'warning', 'error']
const Ctor = Vue.extend(main);

Ctor.prototype.close = function () {
  if (instance) {
    instance = null
  }

  if (this.$el && this.$el.parentNode) {
    this.$el.parentNode.removeChild(this.$el)
  }

  this.$destroy()
}

const Alert = (options = {}) => {
  if (instance) return instance

  return new Promise((resolve, reject) => {
    let propsData = null

    // 如果直接调用 但传的是个字符串
    // 那么显示成功的 且展示传入的字符串
    if (typeof options === 'string') {
      propsData = { message: options }
    } else if (typeof options === 'object') {
      propsData = { ...options }
    } else if (typeof options === 'undefined') {
      propsData = {}
    }

    try {
      instance = new Ctor({
        data: { types },
        propsData
      }).$mount();

      document.body.appendChild(instance.$el);

      instance.$on('modelInput', () => {
        instance.close()
        resolve('confirm')
      });
    } catch (e) { reject(e); }

    return instance
  })
};

// 给各种类型提供一种直接调用的方法
types.forEach(type => Alert[type] = (message) => Alert({ type, message }))

export default Alert
